import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { ApiProvider, useApiProviderCtx, ApiProviderCtx } from './context/api';
import { LocaleProvider, useLocaleProviderCtx } from './context/locale';

/*import Root, { loader as rootLoader } from './routes/root';
import SdgsOverview, {
  sdgsoverviewloader,
  //action as rootAction,
} from './routes/root/sdgsoverview';

import SdgIndex, {
  sdgindexloader,
  //action as rootAction,
} from './routes/root/sdgindex';

import Settings from './routes/root/settings';
import Profile from './routes/root/profile';
//Auth
import {auth} from './routes/auth/auth.routes'; 
//
import SdgArticleInput, { sdgarticleinputloader, sdgarticleinputaction } from './routes/root/sdgarticleinput';

*/

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Landing, { landingloader } from './pages';

import MostRecent, { mostrloader } from './pages/most-recent';

import SdgRecent, { sdgrloader } from './pages/sdg-recent';
import ViewArticle, { viewaloader } from './pages/view-article';
import './index.scss';
//
import PrivacyPolicy from './pages/privacy-policy';
import ContactUs from './pages/contact';
import Pricing from './pages/pricing';
import Faq, { faqloader } from './pages/faq';
import About from './pages/about';
import TermsOfUse from './pages/terms';

//const lang = 'en'; //i18n.language;

const AppRoot = () => {
  const apiContext = React.useContext(ApiProviderCtx);

  //const { lang } = useLocaleProviderCtx();

  //sdgslug

  const k4dUrouter = createBrowserRouter([
    {
      path: `/:lang/most-recent`,
      loader: mostrloader(apiContext),
      element: <MostRecent />,
    },
    {
      path: `/:lang/pricing`,
      //loader: mostrloader(apiContext),
      element: <Pricing />,
    },
    {
      path: `/:lang/about`,
      //loader: mostrloader(apiContext),
      element: <About />,
    },
    {
      path: `/:lang/faq`,
      loader: faqloader(apiContext),
      element: <Faq />,
    },
    {
      path: `/:lang/contact-us`,
      //loader: mostrloader(apiContext),
      element: <ContactUs />,
    },
    {
      path: `/:lang/terms-of-use`,
      //loader: mostrloader(apiContext),
      element: <TermsOfUse />,
    },
    {
      path: `/:lang/privacy-policy`,
      //loader: mostrloader(apiContext),
      element: <PrivacyPolicy />,
    },
    {
      path: `/:lang/:sdgslug`,
      loader: sdgrloader(apiContext),
      element: <SdgRecent />,
    },
    {
      path: `/:lang/:key/:articleslug`,
      loader: viewaloader(apiContext),
      element: <ViewArticle />,
    },
    {
      path: `/:lang`,
      loader: landingloader(apiContext),
      element: <Landing />,
    },
    {
      path: `*`,
      loader: landingloader(apiContext),
      element: <Landing />,
    },
  ]);
  /*const k4dUrouter = createBrowserRouter([
    {...auth},
    {
      path: `/:lang`,
      element: <Root />,
      //errorElement: <ErrorPage />,
      loader: rootLoader,
      children: [
        {
          path: '',
          loader: sdgsoverviewloader,
          //action: rootAction,
          element: <SdgsOverview />,
        },
        {
          path: 'overview/:slug',
          loader: sdgindexloader,
          //action: rootAction,
          element: <SdgIndex />,
        },
        {
          path: 'settings',
          //loader: sdgindexloader,
          //action: rootAction,
          element: <Settings />,
          children: [],
        },
        {
          path: 'profile',
          //loader: sdgindexloader,
          //action: rootAction,
          element: <Profile />,
          children: [],
        },
      ],
    },
    {
      path: '*',
      element: (
        <div>
          Not found <br />
          <a href={`/${lang}`}>Home</a>
        </div>
      ),
    },
  ]);*/

  return <RouterProvider router={k4dUrouter} />;
};

/*
      {
        path: 'overview/:slug/new-article',
        loader: sdgarticleinputloader,
        action: sdgarticleinputaction,
        element: <SdgArticleInput />,
      },*/

export default function K4dL() {
  return (
    <>
      <LocaleProvider>
        <ApiProvider>
          <AppRoot />
        </ApiProvider>
        <ToastContainer />
      </LocaleProvider>
    </>
  );
  /*return (
    <>
      
          <AppRoot /> 
        <ToastContainer /> 
    </>
  );*/
}
